export default __webpack_public_path__ + "static/media/case2-2 (3).2b9fd53a.png";